<div class="content" data-test-id="reset-password-content">
  @if (invalidId()) {
  <div
    class="lockedOutSection"
    data-test-id="reset-password-locked-out-section"
  >
    <p class="messageTitle">Oops! Something went wrong.</p>
    <p class="messageText">
      There seem to be missing a valid ID to identify your account. Please
      <a
        class="forgot-password-inline-link"
        routerLink="/forgot-password"
        data-test-id="reset-password-forgot-password-link"
        >reset your password</a
      >
      here to get a new email with a link to reset your password.
    </p>
  </div>
  } @else {
  <form
    class="form"
    data-test-id="reset-password-form"
    (submit)="submit($event)"
  >
    <app-text
      [size]="TextSize.TITLE_3"
      [height]="TextHeight.TITLE_4"
      [weight]="TextWeight.BOLD"
      [color]="TextColor.NEUTRAL_8"
      [spacingBottom]="Spacing.SMALL"
      [align]="TextAlign.CENTER"
      >Reset Password</app-text
    >
    <app-text
      [size]="TextSize.BODY_2"
      [height]="TextHeight.BODY_2"
      [weight]="TextWeight.REGULAR"
      [color]="TextColor.NEUTRAL_6"
      [spacingBottom]="Spacing.LARGE"
      >Enter your new password</app-text
    >
    <app-text-input
      class="field"
      [(value)]="password"
      [type]="InputType.PASSWORD"
      placeholder="{{ 'common.enterNewPassword' | translate }}"
      [error]="passwordError"
      [size]="InputSize.LARGE"
      [width]="InputWidth.FULL"
      [direction]="InputDirection.VERTICAL"
      [spacingBottom]="Spacing.MEDIUM"
      data-test-id="reset-password-password-input"
    ></app-text-input>
    <app-text-input
      class="field"
      [(value)]="confirmPassword"
      placeholder="{{ 'common.confirmPassword' | translate }}"
      [error]="passwordError"
      errorMessage="{{ 'login.enterPassword' | translate }}"
      [size]="InputSize.LARGE"
      [width]="InputWidth.FULL"
      [direction]="InputDirection.VERTICAL"
      [spacingBottom]="Spacing.LARGE"
      data-test-id="reset-password-confirm-password-input"
    ></app-text-input>
    <div class="check-container" data-test-id="reset-password-check-container">
      <app-checkmark
        [checked]="passwordCriteria.lengthCheck()"
        text="{{ 'login.charsCheck' | translate }}"
        data-test-id="reset-password-length-check"
      ></app-checkmark>
      <app-checkmark
        [checked]="passwordCriteria.uppercase()"
        text="{{ 'login.uppercaseCheck' | translate }}"
        data-test-id="reset-password-uppercase-check"
      ></app-checkmark>
      <app-checkmark
        [checked]="passwordCriteria.lowercase()"
        text="{{ 'login.lowercaseCheck' | translate }}"
        data-test-id="reset-password-lowercase-check"
      ></app-checkmark>
      <app-checkmark
        [checked]="passwordCriteria.number()"
        text="{{ 'login.numberCheck' | translate }}"
        data-test-id="reset-password-number-check"
      ></app-checkmark>
      <app-checkmark
        [checked]="passwordCriteria.specialChar()"
        text="{{ 'login.specialCheck' | translate }}"
        data-test-id="reset-password-special-check"
      ></app-checkmark>
      <app-checkmark
        [checked]="passwordCriteria.match()"
        text="{{ 'login.matchCheck' | translate }}"
        data-test-id="reset-password-match-check"
      ></app-checkmark>
    </div>
    <app-view
      [direction]="ViewDirection.COLUMN"
      [gap]="Spacing.LARGE"
      [align]="ViewAlign.CENTER"
    >
      <app-button
        [type]="ButtonType.PRIMARY"
        [nativeType]="NativeButtonType.SUBMIT"
        [size]="ButtonSize.LARGE"
        [disabled]="!isFormValid()"
        [spacingBottom]="Spacing.NONE"
        data-test-id="reset-password-reset-button"
        >{{ 'common.reset' | translate }}</app-button
      >
      <a
        class="form-link"
        routerLink="/forgot-password"
        data-test-id="reset-password-return-to-login-link"
      >
        {{ 'common.returnToLogin' | translate }}
      </a>
    </app-view>
  </form>
  }
  <app-toast [position]="ToastPosition.FORM"></app-toast>
</div>
